import React, { useEffect } from "react";
import { useStyles } from "./Styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { Button, FormControl, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

// @ts-ignore
function BookForm({
  handleAddEvent,
  handleCancelEvent,
  isLoading,
  isEditMode,
  recordToUpdate,
  handleEditEvent,
}: {
  handleAddEvent: (data: any) => void;
  handleCancelEvent: () => void;
  isLoading: boolean;
  isEditMode: boolean;
  recordToUpdate: any;
  handleEditEvent: (data: any) => void;
}) {
  // css for module
  const classes = useStyles();

  // router object
  const navigate = useNavigate();

  // module(s) for api
  const moduleMain = "book";

  // translation
  const { t } = useTranslation();

  // UI methods
  const [loading, setLoading] = React.useState(true);

  // form data
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm(); // watch is used to get the value e.g watch("name")

  // form methods
  const onSubmit = (_data: any) => {
    if (!isEditMode) {
      handleAddEvent(_data);
    } else {
      handleEditEvent(_data);
    }
  };

  // ui handlers
  const onCancel = () => {
    handleCancelEvent();
  };

  // hooks
  useEffect(() => {
    if (isEditMode) {
      reset(recordToUpdate);
    }
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <Card sx={{ width: "30vw", maxHeight: "90vh", overflowY: "auto" }}>
        {/* Form start */}
        <form className="row px-1 px-md-0" onSubmit={handleSubmit(onSubmit)}>
          <CardContent>
            <div className="py-2 px-md-4 px-2">
              <div className="row mx-2">
                <div className="col-md-12 my-2">
                  {/* Form name */}
                  <h4 className="pb-2">
                    {isEditMode ? t("common.edit") : t("common.add")} {"Book"}
                  </h4>
                </div>

                {/* Field name */}
                <div className="col-md-12 mt-2">
                  <FormControl fullWidth>
                    <TextField
                      id="titleInput"
                      {...register("name", { required: true })}
                      label={t("hadithbook.name")}
                      type={"text"}
                      error={!!errors.name}
                      variant="outlined"
                      className="full-width"
                    />
                  </FormControl>
                </div>

                {/* Author name */}
                <div className="col-md-12 mt-2">
                  <FormControl fullWidth>
                    <TextField
                      id="titleInput"
                      {...register("author", { required: true })}
                      label={t("hadithbook.author")}
                      type={"text"}
                      error={!!errors.author}
                      variant="outlined"
                      className="full-width"
                    />
                  </FormControl>
                </div>

                {/* Book Type name */}
                <div className="col-md-12 mt-2">
                  <FormControl fullWidth>
                    <TextField
                      id="titleInput"
                      {...register("type", { required: true })}
                      label={"Type"}
                      type={"text"}
                      error={!!errors.author}
                      variant="outlined"
                      className="full-width"
                    />
                  </FormControl>
                </div>
              </div>
            </div>
          </CardContent>
          <CardActions>
            <div
              className="pb-4 pt-2 px-md-4 px-2 "
              style={{ width: "100%", textAlign: "right" }}
            >
              {/* Cancel Button */}
              <Button variant="outlined" onClick={onCancel}>
                {t("common.cancel")}
              </Button>
              &nbsp;&nbsp;
              {/* Okay Button */}
              <LoadingButton
                loading={isLoading}
                type="submit"
                variant="contained"
                className="bg-custom-gradient"
              >
                {isEditMode ? t("common.edit") : t("common.add")}
              </LoadingButton>
              &nbsp;
            </div>
          </CardActions>
        </form>
      </Card>
    </Box>
  );
}

export default BookForm;
